const entityId = (value) => value?.id ?? value ?? null;

export const applyTechnologyDefaultUnit = (row, fieldName, value, technologies = []) => {
  const next = {...(row || {}), [fieldName]: value};
  if (fieldName !== 'technology') return next;

  const technologyId = entityId(value);
  const technology = technologies.find(option => Number(entityId(option)) === Number(technologyId));
  const defaultUnitId = entityId(technology?.default_unit ?? technology?.defaultUnit);

  return defaultUnitId ? {...next, unit: defaultUnitId} : next;
};

export const applySchemaProductionDefaults = (state, defaults = []) => {
  if (!Array.isArray(defaults) || defaults.length === 0 || (state?.production_items || []).length > 0) {
    return state;
  }

  return {
    ...state,
    production_items: defaults.map(defaultItem => ({...defaultItem})),
  };
};
